import { Grid } from '@material-ui/core';
import React from 'react';
import SkillsProgress from '../common/SkillsProgress';
import OverallCards from '../common/OverallCards';
import { ReportEntityType } from 'components/ReportsModule/types';
import useSkillProgress from '../hooks/use-skill-progress';
import useClassroomEngagement from '../hooks/use-classroom-engagement';
import Engagement from './Engagement';
import { useTranslation } from 'react-i18next';

/** Multi purpose for school, user, and user group */
const OrganizationReport = () => {
  const { t } = useTranslation('Classrooms');
  const [
    {
      setList,
      selectedProductCurriculumId,
      curriculumLessonReport,
      curriculumLessonLoading,
      prmCurriculumProgressReport,
      curriculumProgressLoading
    },
    { setSelectedProductCurriculumId }
  ] = useSkillProgress();
  const [
    { prmClassroomEngagementCurriculumReport, selectedProductCurriculumId: productId, loading },
    { setProductCurriculumId }
  ] = useClassroomEngagement();

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <OverallCards
          prmCurriculumProgressReport={prmCurriculumProgressReport}
          progressLoading={curriculumProgressLoading}
        />
      </Grid>
      <Grid item xs={12}>
        <SkillsProgress
          curriculumLessonReport={curriculumLessonReport!}
          setList={setList!}
          selected={selectedProductCurriculumId}
          setSelected={setSelectedProductCurriculumId}
          entityType={ReportEntityType.SCHOOL}
          loading={curriculumLessonLoading!}
        />
      </Grid>
      <Grid item xs={12}>
        <Engagement
          entityType={t('Classes')}
          loading={loading}
          setList={setList!}
          prmClassroomEngagementCurriculumReport={prmClassroomEngagementCurriculumReport!}
          setId={setProductCurriculumId}
          selectedId={productId!}
        />
      </Grid>
    </Grid>
  );
};

export default OrganizationReport;
